import React from 'react'
import { Play, Player } from '../../Common/SI'
import { AdversaryOutcomeTable } from './AdversaryOutcomeTable'
import { DifficultyOutcomeTable } from './DifficultyOutcomeTable'
import { IslandStateTable } from './IslandStateTable'
import { LayoutOutcomeTable } from './LayoutOutcomeTable'
import { OutcomeTypeTable } from './OutcomeTypeTable'
import { SpiritCountOutcomeTable } from './SpiritCountOutcomeTable'
import { SpiritOutcomeTable } from './SpiritOutcomeTable'
import { TurnOutcomeTable } from './TurnOutcomeTable'
import { PlayerSpiritTable } from './PlayerSpiritTable'
import { SpiritAdversaryTable } from './SpiritAdversaryTable'
import { AspectOutcomeTable } from './AspectOutcomeTable'

import './Tables.css'
import { LocationOutcomeTable } from './LocationOutcomeTable'

export interface TablesProps {
	difficulties: number[]
	layouts: string[]
	locations: string[]
	maxSpirits: number
	players: Player[]
	plays: Play[]
}

export function Tables(props: TablesProps): JSX.Element {

	const playedPlayers = props.players.filter(player => props.plays.some(play => play.players.some(playedPlayer => playedPlayer.name === player.name)))

	return (
		<div className='tables'>
			<PlayerSpiritTable players={playedPlayers} plays={props.plays} />
			<SpiritAdversaryTable plays={props.plays} />
			<SpiritOutcomeTable plays={props.plays} />
			<AspectOutcomeTable plays={props.plays} />
			<IslandStateTable plays={props.plays} />
			<DifficultyOutcomeTable plays={props.plays} difficulties={props.difficulties} />
			<TurnOutcomeTable plays={props.plays} />
			<OutcomeTypeTable plays={props.plays} />
			<LayoutOutcomeTable plays={props.plays} layouts={props.layouts} />
			<LocationOutcomeTable plays={props.plays} locations={props.locations} />
			<AdversaryOutcomeTable plays={props.plays} />
			<SpiritCountOutcomeTable plays={props.plays} maxSpirits={props.maxSpirits} />
		</div>
	)
}
